import { useMutation } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api-client";
import type {
  SubmitCalibrationCaseData,
  SubmitCalibrationCaseRequest,
} from "@/hooks/queries/calibration-submit-types";

// POST /calibration/cases/{case_id}/submit (Story 8.10, AC4). The 202 hands back a
// submission handle and the case enters the scoring worker's queue; the screen then
// polls `useCaseSubmissionStatus` for the outcome.
//
// NO onSuccess invalidation here, deliberately. The board's status key must be
// invalidated only once the case reaches a TERMINAL `scored` (AC5) — busting it at
// 202 would refetch a board that still reads `in_progress` and burn the one refetch
// the destination derivation depends on.
//
// Coded refusals (CAL-409 / CAL-409-DUP / CAL-422-* / CAL-404) surface as `ApiError`
// with `.code` intact so the screen can branch per refusal rather than showing one
// generic failure.

export function useSubmitCalibrationCase(caseId: string | undefined) {
  return useMutation({
    mutationFn: (body: SubmitCalibrationCaseRequest) =>
      apiFetch<SubmitCalibrationCaseData>(
        `/calibration/cases/${encodeURIComponent(caseId ?? "")}/submit`,
        { method: "POST", body },
      ),
  });
}
